import { createContext, useState } from 'react';

export const PlateSelectionContext = createContext();
export const PlateInteractionDispatch = createContext();

export default function PlateSelectionProvider({children}){

  const [selected, setSelected] = useState({});


  function clear(){
    setSelected({});
  }


  //currently DOES NOT SUPPORT
  //SHIFT / CONTROL to unselect in multiselect

  function trySelect(e, items){

    let shift = e.shiftKey;
    let ctrl = e.ctrlKey;
    let meta = e.metaKey; 


    let newLiquids = items.liquids || [];
    let newWells = items.wells || [];

    if( newWells.length > 0 ){

      let wellsToKeep = ((ctrl||meta) && selected.wells) || [];

      setSelected({wells:[...wellsToKeep,...newWells]})

    }else{
      // going with liquids

      let liquidsToKeep = ((ctrl||meta) && selected.liquids) || [];


      setSelected({liquids:[...liquidsToKeep,...newLiquids]})
    }


    // if wells selected, only look at wells

  }

  function onEvent(action){
    let { type } = action;
    switch(type){
      case "clearSelection":{
        clear();
        return;
      }
      case "click":{

        let { event } = action;
        trySelect(event,action.args)

        return;

      }
      default:{
        throw Error(`Unregistered event '${type}'.`);
      }
    }
  }


  return (
    <PlateInteractionDispatch.Provider value={onEvent}>
      <PlateSelectionContext.Provider value={selected}>
        {children}
      </PlateSelectionContext.Provider>
    </PlateInteractionDispatch.Provider>
  )





}
